import React from "react";
import Reveal from "./Reveal";
import { AlertTriangle, Sparkles } from "lucide-react";

/**
 * Problem / Solution — bold split with oversized numbers, light/dark halves,
 * restored "Why Thryvin'?" heading.
 */
const ProblemSolution = () => {
  return (
    <section className="problem-solution-section" id="problem-solution">
      <div className="container">
        <Reveal className="section-header">
          <h2 className="section-title">Why Thryvin'?</h2>
          <p className="section-subtitle">
            Bring your plan, your coach and your progress into one place.
          </p>
        </Reveal>

        <div className="ps-split">
          <Reveal className="ps-card ps-problem" variant="slide-left" delay={60}>
            <div className="ps-meta">
              <span className="ps-marker">
                <AlertTriangle size={18} />
              </span>
              <span className="ps-label">The problem</span>
            </div>
            <p className="ps-stat">01</p>
            <p className="ps-text">
              Knowing what to train next can be the hardest part of getting started.
              A plan gives each session a purpose.
            </p>
          </Reveal>

          <Reveal className="ps-card ps-solution" variant="slide-right" delay={180}>
            <div className="ps-meta">
              <span className="ps-marker ps-marker-bright">
                <Sparkles size={18} />
              </span>
              <span className="ps-label ps-label-bright">The solution</span>
            </div>
            <p className="ps-stat ps-stat-bright">02</p>
            <p className="ps-text ps-text-bright">
              Set your goals, follow your personalised workouts and ask your
              AI coach for guidance. Track each session in Thryvin' on iPhone or Android.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
